import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import Button from '../Button';
import colors from '../../styles/colors';
import { CampaignModal } from '../../util/Campaign';

const TooltipStyles = createGlobalStyle`
.__react_component_tooltip{
      display: inline-block !important;
      max-width: 300px;
    };
    .css-12jo7m5{
      font-size:13px !important;
    };
    .css-1pahdxg-control{
      border-color: ${colors.grey3} !important;
      box-shadow: none !important;
      min-height: 40px;
    }
    .css-yk16xz-control{
      min-height: 40px !important;
    };
`;

const Container = styled.div`
  padding: 20px 15px;
`;
const Text = styled.div`
  font-size: 1.4rem;

  color: ${colors.grey3};
`;
export const CampaignModalTypes = Object.freeze({
  GenCampagianType: 'GENERAL CAMPAIGN',
  TriggerCampaignType: 'TRIGGER CAMPAIGN',

});
export default function TriggerCampaignModal({
  setContentType,
  onCloseModal,
}) {
  const handleChange = (triggerType) => {
    setContentType(triggerType);
    onCloseModal(false);
  };
  return (
    <Container>
      <Text>
        You want to create a General campaign or a Trigger campaign
      </Text>
      <Button
        margin="30px 0px 0px 0px"
        text={CampaignModalTypes.GenCampagianType}
        width="100%"
        onClick={() => handleChange(CampaignModal.GenCampagian)}
      />
      <Button
        margin="20px 0px 0px 0px"
        text={CampaignModalTypes.TriggerCampaignType}
        width="100%"
        onClick={() => handleChange(CampaignModal.TriggerCampaign)}
      />
      <TooltipStyles />
    </Container>
  );
}
